var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBattery100PercentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0V2H1.5C1.10218 2 0.720644 2.15804 0.43934 2.43934C0.158035 2.72064 0 3.10218 0 3.5L0 18.5C0 18.8978 0.158035 19.2794 0.43934 19.5607C0.720644 19.842 1.10218 20 1.5 20H8.5C8.89782 20 9.27936 19.842 9.56066 19.5607C9.84196 19.2794 10 18.8978 10 18.5V3.5C10 3.10218 9.84196 2.72064 9.56066 2.43934C9.27936 2.15804 8.89782 2 8.5 2H7.5V0H2.5ZM8.5 3C8.63261 3 8.75979 3.05268 8.85355 3.14645C8.94732 3.24021 9 3.36739 9 3.5V18.5C9 18.6326 8.94732 18.7598 8.85355 18.8536C8.75979 18.9473 8.63261 19 8.5 19H1.5C1.36739 19 1.24021 18.9473 1.14645 18.8536C1.05268 18.7598 1 18.6326 1 18.5V3.5C1 3.36739 1.05268 3.24021 1.14645 3.14645C1.24021 3.05268 1.36739 3 1.5 3H8.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.388V17.6115C2 17.7144 2.04086 17.8132 2.11361 17.886C2.18636 17.9589 2.28505 17.9999 2.388 18H7.612C7.71495 17.9999 7.81364 17.9589 7.88639 17.886C7.95914 17.8132 8 17.7144 8 17.6115V4.388C8 4.2851 7.95912 4.18641 7.88636 4.11364C7.81359 4.04088 7.7149 4 7.612 4H2.388C2.2851 4 2.18641 4.04088 2.11364 4.11364C2.04088 4.18641 2 4.2851 2 4.388Z",
    fill: "#4AAD40"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBattery100PercentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Battery100_percent_icon.b8233bcc683e00c8539dfe7f21c29a77.svg";